<span>
    Climb&trade; by
    <a href="https://www.rockstepsolutions.com" target="_blank" rel="noopener">RockStep Solutions</a>
</span>
<a routerLink="/versions">Version {{ version }}</a>
